import { Panel } from "@/components/dash/Ui";

export const RankList = ({ title, items, testid, prefix = "" }) => {
  const max = Math.max(1, ...(items || []).map((i) => i.count));
  return (
    <Panel data-testid={testid}>
      <h3 className="font-display font-semibold mb-5">{title}</h3>
      {!items?.length && <p className="text-sm text-slate-500">No data yet</p>}
      <ul className="space-y-3">
        {items?.map((it) => (
          <li key={it.name}>
            <div className="flex justify-between text-sm">
              <span className="truncate text-slate-300">{prefix}{it.name}</span>
              <span className="font-mono text-slate-400">{it.count}</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-800 mt-1.5 overflow-hidden">
              <div className="h-full bg-emerald-500 rounded-full" style={{ width: `${(it.count / max) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </Panel>
  );
};
